export const collections = {
  "articles": {
    "name": "articles",
    "pascalName": "Articles",
    "tableName": "_content_articles",
    "source": [
      {
        "_resolved": true,
        "prefix": "/articles",
        "include": "articles/*.md",
        "cwd": "/opt/build/repo/content"
      }
    ],
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "authors": "json",
      "badge": "json",
      "body": "json",
      "category": "string",
      "date": "string",
      "description": "string",
      "extension": "string",
      "featured": "boolean",
      "head": "json",
      "image": "json",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "sitemap": "json",
      "stem": "string"
    },
    "schema": {
      "$schema": "http://json-schema.org/draft-07/schema#",
      "$ref": "#/definitions/__SCHEMA__",
      "definitions": {
        "articles": {
          "type": "object",
          "properties": {
            "id": {
              "type": "string"
            },
            "stem": {
              "type": "string"
            },
            "extension": {
              "type": "string",
              "enum": [
                "md",
                "yaml",
                "yml",
                "json",
                "csv",
                "xml"
              ]
            },
            "meta": {
              "type": "object",
              "additionalProperties": {}
            },
            "path": {
              "type": "string"
            },
            "title": {
              "type": "string"
            },
            "description": {
              "type": "string"
            },
            "seo": {
              "allOf": [
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    }
                  }
                },
                {
                  "type": "object",
                  "additionalProperties": {}
                }
              ],
              "default": {}
            },
            "body": {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string"
                },
                "children": {},
                "toc": {}
              },
              "required": [
                "type"
              ],
              "additionalProperties": false
            },
            "navigation": {
              "anyOf": [
                {
                  "type": "boolean"
                },
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    },
                    "icon": {
                      "type": "string",
                      "$content": {
                        "editor": {
                          "input": "icon"
                        }
                      }
                    }
                  },
                  "required": [
                    "title",
                    "description",
                    "icon"
                  ],
                  "additionalProperties": false
                }
              ],
              "default": true
            },
            "sitemap": {
              "type": "object",
              "properties": {
                "loc": {
                  "type": "string"
                },
                "lastmod": {
                  "type": "string",
                  "format": "date-time"
                },
                "changefreq": {
                  "type": "string",
                  "enum": [
                    "always",
                    "hourly",
                    "daily",
                    "weekly",
                    "monthly",
                    "yearly",
                    "never"
                  ]
                },
                "priority": {
                  "type": "number"
                },
                "images": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "loc": {
                        "type": "string"
                      },
                      "caption": {
                        "type": "string"
                      },
                      "geo_location": {
                        "type": "string"
                      },
                      "title": {
                        "type": "string"
                      },
                      "license": {
                        "type": "string"
                      }
                    },
                    "required": [
                      "loc"
                    ],
                    "additionalProperties": false
                  }
                },
                "videos": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "content_loc": {
                        "type": "string"
                      },
                      "player_loc": {
                        "type": "string"
                      },
                      "duration": {
                        "type": "string"
                      },
                      "expiration_date": {
                        "type": "string",
                        "format": "date-time"
                      },
                      "rating": {
                        "type": "number"
                      },
                      "view_count": {
                        "type": "number"
                      },
                      "publication_date": {
                        "type": "string",
                        "format": "date-time"
                      },
                      "family_friendly": {
                        "type": "boolean"
                      },
                      "tag": {
                        "type": "string"
                      },
                      "category": {
                        "type": "string"
                      },
                      "restriction": {
                        "type": "object",
                        "properties": {
                          "relationship": {
                            "type": "string",
                            "const": "allow"
                          },
                          "value": {
                            "type": "string"
                          }
                        },
                        "additionalProperties": false
                      },
                      "gallery_loc": {
                        "type": "string"
                      },
                      "price": {
                        "type": "string"
                      },
                      "requires_subscription": {
                        "type": "boolean"
                      },
                      "uploader": {
                        "type": "string"
                      }
                    },
                    "required": [
                      "content_loc"
                    ],
                    "additionalProperties": false
                  }
                }
              },
              "additionalProperties": false
            },
            "date": {
              "type": "string"
            },
            "authors": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "name": {
                    "type": "string"
                  },
                  "description": {
                    "type": "string"
                  },
                  "avatar": {
                    "type": "object",
                    "properties": {
                      "src": {
                        "type": "string"
                      }
                    },
                    "additionalProperties": false
                  },
                  "to": {
                    "type": "string"
                  }
                },
                "required": [
                  "name"
                ],
                "additionalProperties": false
              }
            },
            "badge": {
              "type": "object",
              "properties": {
                "label": {
                  "type": "string"
                },
                "color": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            "image": {
              "type": "object",
              "properties": {
                "src": {
                  "type": "string"
                },
                "alt": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            "head": {
              "type": "object",
              "properties": {
                "title": {
                  "type": "string"
                },
                "description": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            "category": {
              "type": "string"
            },
            "featured": {
              "type": "boolean"
            }
          },
          "required": [
            "id",
            "stem",
            "extension",
            "meta",
            "path",
            "title",
            "description",
            "body",
            "date"
          ],
          "additionalProperties": false
        }
      }
    },
    "tableDefinition": "CREATE TABLE IF NOT EXISTS _content_articles (id TEXT PRIMARY KEY, \"title\" VARCHAR, \"authors\" TEXT NULL, \"badge\" TEXT NULL, \"body\" TEXT, \"category\" VARCHAR NULL, \"date\" VARCHAR, \"description\" VARCHAR, \"extension\" VARCHAR, \"featured\" BOOLEAN NULL, \"head\" TEXT NULL, \"image\" TEXT NULL, \"meta\" TEXT, \"navigation\" TEXT DEFAULT true, \"path\" VARCHAR, \"seo\" TEXT DEFAULT '{}', \"sitemap\" TEXT NULL, \"stem\" VARCHAR, \"__hash__\" TEXT UNIQUE);"
  },
  "videos": {
    "name": "videos",
    "pascalName": "Videos",
    "tableName": "_content_videos",
    "source": [
      {
        "_resolved": true,
        "prefix": "/videos",
        "include": "videos/*.md",
        "cwd": "/opt/build/repo/content"
      }
    ],
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "badge": "string",
      "body": "json",
      "createdAt": "string",
      "date": "string",
      "description": "string",
      "extension": "string",
      "image": "json",
      "mediaType": "string",
      "mediaUrl": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    },
    "schema": {
      "$schema": "http://json-schema.org/draft-07/schema#",
      "$ref": "#/definitions/__SCHEMA__",
      "definitions": {
        "videos": {
          "type": "object",
          "properties": {
            "id": {
              "type": "string"
            },
            "stem": {
              "type": "string"
            },
            "extension": {
              "type": "string",
              "enum": [
                "md",
                "yaml",
                "yml",
                "json",
                "csv",
                "xml"
              ]
            },
            "meta": {
              "type": "object",
              "additionalProperties": {}
            },
            "path": {
              "type": "string"
            },
            "title": {
              "type": "string"
            },
            "description": {
              "type": "string"
            },
            "seo": {
              "allOf": [
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    }
                  }
                },
                {
                  "type": "object",
                  "additionalProperties": {}
                }
              ],
              "default": {}
            },
            "body": {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string"
                },
                "children": {},
                "toc": {}
              },
              "required": [
                "type"
              ],
              "additionalProperties": false
            },
            "navigation": {
              "anyOf": [
                {
                  "type": "boolean"
                },
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    },
                    "icon": {
                      "type": "string",
                      "$content": {
                        "editor": {
                          "input": "icon"
                        }
                      }
                    }
                  },
                  "required": [
                    "title",
                    "description",
                    "icon"
                  ],
                  "additionalProperties": false
                }
              ],
              "default": true
            },
            "mediaType": {
              "type": "string"
            },
            "mediaUrl": {
              "type": "string"
            },
            "badge": {
              "type": "string"
            },
            "date": {
              "type": "string"
            },
            "createdAt": {
              "type": "string"
            },
            "image": {
              "type": "object",
              "properties": {
                "src": {
                  "type": "string"
                },
                "alt": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            }
          },
          "required": [
            "id",
            "stem",
            "extension",
            "meta",
            "path",
            "title",
            "description",
            "body",
            "mediaType",
            "mediaUrl"
          ],
          "additionalProperties": false
        }
      }
    },
    "tableDefinition": "CREATE TABLE IF NOT EXISTS _content_videos (id TEXT PRIMARY KEY, \"title\" VARCHAR, \"badge\" VARCHAR NULL, \"body\" TEXT, \"createdAt\" VARCHAR NULL, \"date\" VARCHAR NULL, \"description\" VARCHAR, \"extension\" VARCHAR, \"image\" TEXT NULL, \"mediaType\" VARCHAR, \"mediaUrl\" VARCHAR, \"meta\" TEXT, \"navigation\" TEXT DEFAULT true, \"path\" VARCHAR, \"seo\" TEXT DEFAULT '{}', \"stem\" VARCHAR, \"__hash__\" TEXT UNIQUE);"
  },
  "podcasts": {
    "name": "podcasts",
    "pascalName": "Podcasts",
    "tableName": "_content_podcasts",
    "source": [
      {
        "_resolved": true,
        "prefix": "/podcasts",
        "include": "podcasts/*.md",
        "cwd": "/opt/build/repo/content"
      }
    ],
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "badge": "string",
      "body": "json",
      "createdAt": "string",
      "date": "string",
      "description": "string",
      "extension": "string",
      "image": "json",
      "mediaType": "string",
      "mediaUrl": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    },
    "schema": {
      "$schema": "http://json-schema.org/draft-07/schema#",
      "$ref": "#/definitions/__SCHEMA__",
      "definitions": {
        "podcasts": {
          "type": "object",
          "properties": {
            "id": {
              "type": "string"
            },
            "stem": {
              "type": "string"
            },
            "extension": {
              "type": "string",
              "enum": [
                "md",
                "yaml",
                "yml",
                "json",
                "csv",
                "xml"
              ]
            },
            "meta": {
              "type": "object",
              "additionalProperties": {}
            },
            "path": {
              "type": "string"
            },
            "title": {
              "type": "string"
            },
            "description": {
              "type": "string"
            },
            "seo": {
              "allOf": [
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    }
                  }
                },
                {
                  "type": "object",
                  "additionalProperties": {}
                }
              ],
              "default": {}
            },
            "body": {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string"
                },
                "children": {},
                "toc": {}
              },
              "required": [
                "type"
              ],
              "additionalProperties": false
            },
            "navigation": {
              "anyOf": [
                {
                  "type": "boolean"
                },
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    },
                    "icon": {
                      "type": "string",
                      "$content": {
                        "editor": {
                          "input": "icon"
                        }
                      }
                    }
                  },
                  "required": [
                    "title",
                    "description",
                    "icon"
                  ],
                  "additionalProperties": false
                }
              ],
              "default": true
            },
            "mediaType": {
              "type": "string"
            },
            "mediaUrl": {
              "type": "string"
            },
            "badge": {
              "type": "string"
            },
            "date": {
              "type": "string"
            },
            "createdAt": {
              "type": "string"
            },
            "image": {
              "type": "object",
              "properties": {
                "src": {
                  "type": "string"
                },
                "alt": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            }
          },
          "required": [
            "id",
            "stem",
            "extension",
            "meta",
            "path",
            "title",
            "description",
            "body",
            "mediaType",
            "mediaUrl"
          ],
          "additionalProperties": false
        }
      }
    },
    "tableDefinition": "CREATE TABLE IF NOT EXISTS _content_podcasts (id TEXT PRIMARY KEY, \"title\" VARCHAR, \"badge\" VARCHAR NULL, \"body\" TEXT, \"createdAt\" VARCHAR NULL, \"date\" VARCHAR NULL, \"description\" VARCHAR, \"extension\" VARCHAR, \"image\" TEXT NULL, \"mediaType\" VARCHAR, \"mediaUrl\" VARCHAR, \"meta\" TEXT, \"navigation\" TEXT DEFAULT true, \"path\" VARCHAR, \"seo\" TEXT DEFAULT '{}', \"stem\" VARCHAR, \"__hash__\" TEXT UNIQUE);"
  },
  "landing": {
    "name": "landing",
    "pascalName": "Landing",
    "tableName": "_content_landing",
    "source": [
      {
        "_resolved": true,
        "prefix": "/landing",
        "include": "landing/*.{yml,yaml}",
        "cwd": "/opt/build/repo/content"
      }
    ],
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "cta": "string",
      "description": "string",
      "extension": "string",
      "features": "string",
      "hero": "string",
      "logos": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "planComparison": "string",
      "pricing": "string",
      "seo": "json",
      "stem": "string"
    },
    "schema": {
      "$schema": "http://json-schema.org/draft-07/schema#",
      "$ref": "#/definitions/__SCHEMA__",
      "definitions": {
        "landing": {
          "type": "object",
          "properties": {
            "id": {
              "type": "string"
            },
            "stem": {
              "type": "string"
            },
            "extension": {
              "type": "string",
              "enum": [
                "md",
                "yaml",
                "yml",
                "json",
                "csv",
                "xml"
              ]
            },
            "meta": {
              "type": "object",
              "additionalProperties": {}
            },
            "path": {
              "type": "string"
            },
            "title": {
              "type": "string"
            },
            "description": {
              "type": "string"
            },
            "seo": {
              "allOf": [
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    }
                  }
                },
                {
                  "type": "object",
                  "additionalProperties": {}
                }
              ],
              "default": {}
            },
            "body": {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string"
                },
                "children": {},
                "toc": {}
              },
              "required": [
                "type"
              ],
              "additionalProperties": false
            },
            "navigation": {
              "anyOf": [
                {
                  "type": "boolean"
                },
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    },
                    "icon": {
                      "type": "string",
                      "$content": {
                        "editor": {
                          "input": "icon"
                        }
                      }
                    }
                  },
                  "required": [
                    "title",
                    "description",
                    "icon"
                  ],
                  "additionalProperties": false
                }
              ],
              "default": true
            },
            "hero": {},
            "features": {},
            "pricing": {},
            "planComparison": {},
            "cta": {},
            "logos": {}
          },
          "required": [
            "id",
            "stem",
            "extension",
            "meta",
            "path",
            "title",
            "description",
            "body"
          ],
          "additionalProperties": false
        }
      }
    },
    "tableDefinition": "CREATE TABLE IF NOT EXISTS _content_landing (id TEXT PRIMARY KEY, \"title\" VARCHAR, \"body\" TEXT, \"cta\" TEXT NULL, \"description\" VARCHAR, \"extension\" VARCHAR, \"features\" TEXT NULL, \"hero\" TEXT NULL, \"logos\" TEXT NULL, \"meta\" TEXT, \"navigation\" TEXT DEFAULT true, \"path\" VARCHAR, \"planComparison\" TEXT NULL, \"pricing\" TEXT NULL, \"seo\" TEXT DEFAULT '{}', \"stem\" VARCHAR, \"__hash__\" TEXT UNIQUE);"
  },
  "testimonials": {
    "name": "testimonials",
    "pascalName": "Testimonials",
    "tableName": "_content_testimonials",
    "source": [
      {
        "_resolved": true,
        "prefix": "/testimonials",
        "include": "testimonials/*.md",
        "cwd": "/opt/build/repo/content"
      }
    ],
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "author": "string",
      "badge": "string",
      "createdAt": "string",
      "description": "string",
      "extension": "string",
      "image": "json",
      "mediaType": "string",
      "mediaUrl": "string",
      "meta": "json",
      "stem": "string",
      "subheading": "string"
    },
    "schema": {
      "$schema": "http://json-schema.org/draft-07/schema#",
      "$ref": "#/definitions/__SCHEMA__",
      "definitions": {
        "testimonials": {
          "type": "object",
          "properties": {
            "id": {
              "type": "string"
            },
            "stem": {
              "type": "string"
            },
            "extension": {
              "type": "string",
              "enum": [
                "md",
                "yaml",
                "yml",
                "json",
                "csv",
                "xml"
              ]
            },
            "meta": {
              "type": "object",
              "additionalProperties": {}
            },
            "mediaType": {
              "type": "string"
            },
            "mediaUrl": {
              "type": "string"
            },
            "badge": {
              "type": "string"
            },
            "title": {
              "type": "string"
            },
            "description": {
              "type": "string"
            },
            "author": {
              "type": "string"
            },
            "subheading": {
              "type": "string"
            },
            "createdAt": {
              "type": "string"
            },
            "image": {
              "type": "object",
              "properties": {
                "src": {
                  "type": "string"
                },
                "alt": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            }
          },
          "required": [
            "id",
            "stem",
            "extension",
            "meta",
            "mediaType"
          ],
          "additionalProperties": false
        }
      }
    },
    "tableDefinition": "CREATE TABLE IF NOT EXISTS _content_testimonials (id TEXT PRIMARY KEY, \"title\" VARCHAR NULL, \"author\" VARCHAR NULL, \"badge\" VARCHAR NULL, \"createdAt\" VARCHAR NULL, \"description\" VARCHAR NULL, \"extension\" VARCHAR, \"image\" TEXT NULL, \"mediaType\" VARCHAR, \"mediaUrl\" VARCHAR NULL, \"meta\" TEXT, \"stem\" VARCHAR, \"subheading\" VARCHAR NULL, \"__hash__\" TEXT UNIQUE);"
  },
  "info": {
    "name": "info",
    "pascalName": "Info",
    "tableName": "_content_info",
    "source": [],
    "type": "data",
    "fields": {},
    "schema": {
      "$ref": "#/definitions/info",
      "definitions": {},
      "$schema": "http://json-schema.org/draft-07/schema#"
    },
    "tableDefinition": "CREATE TABLE IF NOT EXISTS _content_info (id TEXT PRIMARY KEY, \"ready\" BOOLEAN, \"structureVersion\" VARCHAR, \"version\" VARCHAR, \"__hash__\" TEXT UNIQUE);"
  }
}
export const gitInfo = {
  "name": "sixtyfouranalytics",
  "owner": "hutch78",
  "url": "https://github.com/hutch78/sixtyfouranalytics"
}
export const appConfigSchema = {
  "properties": {
    "id": "#appConfig",
    "properties": {
      "icon": {
        "title": "Nuxt Icon",
        "description": "Configure Nuxt Icon module preferences.",
        "tags": [
          "@studioIcon material-symbols:star"
        ],
        "id": "#appConfig/icon",
        "properties": {
          "size": {
            "title": "Icon Size",
            "description": "Set the default icon size.",
            "tags": [
              "@studioIcon material-symbols:format-size-rounded"
            ],
            "tsType": "string | undefined",
            "id": "#appConfig/icon/size",
            "default": {},
            "type": "any"
          },
          "class": {
            "title": "CSS Class",
            "description": "Set the default CSS class.",
            "tags": [
              "@studioIcon material-symbols:css"
            ],
            "id": "#appConfig/icon/class",
            "default": "",
            "type": "string"
          },
          "attrs": {
            "title": "Default Attributes",
            "description": "Attributes applied to every icon component.\n\n@default { \"aria-hidden\": true }",
            "tags": [
              "@studioIcon material-symbols:settings"
            ],
            "tsType": "Record<string, string | number | boolean>",
            "id": "#appConfig/icon/attrs",
            "default": {
              "aria-hidden": true
            },
            "type": "object"
          },
          "mode": {
            "title": "Default Rendering Mode",
            "description": "Set the default rendering mode for the icon component",
            "enum": [
              "css",
              "svg"
            ],
            "tags": [
              "@studioIcon material-symbols:move-down-rounded"
            ],
            "id": "#appConfig/icon/mode",
            "default": "css",
            "type": "string"
          },
          "aliases": {
            "title": "Icon aliases",
            "description": "Define Icon aliases to update them easily without code changes.",
            "tags": [
              "@studioIcon material-symbols:star-rounded"
            ],
            "tsType": "{ [alias: string]: string }",
            "id": "#appConfig/icon/aliases",
            "default": {},
            "type": "object"
          },
          "cssSelectorPrefix": {
            "title": "CSS Selector Prefix",
            "description": "Set the default CSS selector prefix.",
            "tags": [
              "@studioIcon material-symbols:format-textdirection-l-to-r"
            ],
            "id": "#appConfig/icon/cssSelectorPrefix",
            "default": "i-",
            "type": "string"
          },
          "cssLayer": {
            "title": "CSS Layer Name",
            "description": "Set the default CSS `@layer` name.",
            "tags": [
              "@studioIcon material-symbols:layers"
            ],
            "tsType": "string | undefined",
            "id": "#appConfig/icon/cssLayer",
            "default": {},
            "type": "any"
          },
          "cssWherePseudo": {
            "title": "Use CSS `:where()` Pseudo Selector",
            "description": "Use CSS `:where()` pseudo selector to reduce specificity.",
            "tags": [
              "@studioIcon material-symbols:low-priority"
            ],
            "id": "#appConfig/icon/cssWherePseudo",
            "default": true,
            "type": "boolean"
          },
          "collections": {
            "title": "Icon Collections",
            "description": "List of known icon collections name. Used to resolve collection name ambiguity.\ne.g. `simple-icons-github` -> `simple-icons:github` instead of `simple:icons-github`\n\nWhen not provided, will use the full Iconify collection list.",
            "tags": [
              "@studioIcon material-symbols:format-list-bulleted"
            ],
            "tsType": "string[] | null",
            "id": "#appConfig/icon/collections",
            "default": null,
            "type": "any"
          },
          "customCollections": {
            "title": "Custom Icon Collections",
            "tags": [
              "@studioIcon material-symbols:format-list-bulleted"
            ],
            "tsType": "string[] | null",
            "id": "#appConfig/icon/customCollections",
            "default": null,
            "type": "any"
          },
          "provider": {
            "title": "Icon Provider",
            "description": "Provider to use for fetching icons\n\n- `server` - Fetch icons with a server handler\n- `iconify` - Fetch icons with Iconify API, purely client-side\n- `none` - Do not fetch icons (use client bundle only)\n\n`server` by default; `iconify` when `ssr: false`",
            "enum": [
              "server",
              "iconify",
              "none"
            ],
            "tags": [
              "@studioIcon material-symbols:cloud"
            ],
            "type": "\"server\" | \"iconify\" | undefined",
            "id": "#appConfig/icon/provider"
          },
          "iconifyApiEndpoint": {
            "title": "Iconify API Endpoint URL",
            "description": "Define a custom Iconify API endpoint URL. Useful if you want to use a self-hosted Iconify API. Learn more: https://iconify.design/docs/api.",
            "tags": [
              "@studioIcon material-symbols:api"
            ],
            "id": "#appConfig/icon/iconifyApiEndpoint",
            "default": "https://api.iconify.design",
            "type": "string"
          },
          "fallbackToApi": {
            "title": "Fallback to Iconify API",
            "description": "Fallback to Iconify API if server provider fails to found the collection.",
            "tags": [
              "@studioIcon material-symbols:public"
            ],
            "enum": [
              true,
              false,
              "server-only",
              "client-only"
            ],
            "type": "boolean | \"server-only\" | \"client-only\"",
            "id": "#appConfig/icon/fallbackToApi",
            "default": true
          },
          "localApiEndpoint": {
            "title": "Local API Endpoint Path",
            "description": "Define a custom path for the local API endpoint.",
            "tags": [
              "@studioIcon material-symbols:api"
            ],
            "id": "#appConfig/icon/localApiEndpoint",
            "default": "/api/_nuxt_icon",
            "type": "string"
          },
          "fetchTimeout": {
            "title": "Fetch Timeout",
            "description": "Set the timeout for fetching icons.",
            "tags": [
              "@studioIcon material-symbols:timer"
            ],
            "id": "#appConfig/icon/fetchTimeout",
            "default": 1500,
            "type": "number"
          },
          "customize": {
            "title": "Customize callback",
            "description": "Customize icon content (replace stroke-width, colors, etc...).",
            "tags": [
              "@studioIcon material-symbols:edit"
            ],
            "type": "IconifyIconCustomizeCallback",
            "id": "#appConfig/icon/customize"
          }
        },
        "type": "object",
        "default": {
          "size": {},
          "class": "",
          "attrs": {
            "aria-hidden": true
          },
          "mode": "css",
          "aliases": {},
          "cssSelectorPrefix": "i-",
          "cssLayer": {},
          "cssWherePseudo": true,
          "collections": null,
          "customCollections": null,
          "iconifyApiEndpoint": "https://api.iconify.design",
          "fallbackToApi": true,
          "localApiEndpoint": "/api/_nuxt_icon",
          "fetchTimeout": 1500
        }
      }
    },
    "type": "object",
    "default": {
      "icon": {
        "size": {},
        "class": "",
        "attrs": {
          "aria-hidden": true
        },
        "mode": "css",
        "aliases": {},
        "cssSelectorPrefix": "i-",
        "cssLayer": {},
        "cssWherePseudo": true,
        "collections": null,
        "customCollections": null,
        "iconifyApiEndpoint": "https://api.iconify.design",
        "fallbackToApi": true,
        "localApiEndpoint": "/api/_nuxt_icon",
        "fetchTimeout": 1500
      }
    }
  },
  "default": {
    "icon": {
      "size": {},
      "class": "",
      "attrs": {
        "aria-hidden": true
      },
      "mode": "css",
      "aliases": {},
      "cssSelectorPrefix": "i-",
      "cssLayer": {},
      "cssWherePseudo": true,
      "collections": null,
      "customCollections": null,
      "iconifyApiEndpoint": "https://api.iconify.design",
      "fallbackToApi": true,
      "localApiEndpoint": "/api/_nuxt_icon",
      "fetchTimeout": 1500
    }
  }
}